// extracted by mini-css-extract-plugin
export default {"serviceGrid":"Service_serviceGrid__HLtx7","serviceSection":"Service_serviceSection__MBaSN"};